

/** 生成一组计算属性
 *  @param {String} parent 数据父级字段名称
 *  @param {Object} rules 生成计算属性规则
 *  @return {Object} 计算属性组
 *  @author 王汝鹏
 *  @version 2020-01-13
 */
export const makeComputedGroup = function(parent, rules) {
  // 存放计算属性组
  let computedGroup = {};
  
  // 遍历计算属性生成规则
  for (let attr in rules) {
    let rule = rules[attr];

    // 规则为字符串 
    // 例如: a:"a"  
    // 默认生成对应 get、set 方法 
    // 例如: a: { 
    //            get() { return this[parent].a; }, 
    //            set(val) { this[parent].a = val; } 
    //          }
    if (typeof rule === 'string') {
      let originalAttr = rule;
      Reflect.set(computedGroup, attr, { 
        get() { return this[parent][originalAttr]; }, 
        set(val) { this[parent][originalAttr] = val; }
      });
    }

    // 规则为对象类型 
    // 例如: a: { 
    //            get:'exampleA', 
    //            set(val) { return `hello ${val}`; } 
    //          }
    // 根据规则生成 get、set 方法 
    // 例如: a: { 
    //            get() { return this[parent].exampleA; }, 
    //            set(val) { this[parent].a = `hello ${val}`; } 
    //          }
    if (typeof rule === 'object') {
      let { attr:originalAttr=attr, get, set } = rule;
      
      if (get || set) { Reflect.set(computedGroup, attr, {}); }
      if (typeof get === 'string') { Reflect.set(computedGroup[attr], 'get', function() { return this[parent][get]; }); }
      if (typeof set === 'string') { Reflect.set(computedGroup[attr], 'set', function(val) { this[parent][set] = val; }); }
      if (typeof get === 'function') { Reflect.set(computedGroup[attr], 'get', function() { return get.bind(this)(this[parent][originalAttr]); }); }
      if (typeof set === 'function') { Reflect.set(computedGroup[attr], 'set', function(val) { this[parent][originalAttr] = set.bind(this)(val); }); }
      if (Object.keys(computedGroup[attr]).length === 0) { Reflect.deleteProperty(computedGroup, attr); }
    }
  }
  return computedGroup;
}






// WEBPACK FOOTER //
// ./src/utils/computed_utils.js